import React, { Children } from 'react';
import { connect } from 'react-redux';
import { is } from 'ramda';
// import { objectDiff } from '../../utils';

export default (childrenMapStateToProps, propExceptions, LoadingFragment) => AsyncComponent => {
  //propietat que es indicarà si el component està llest per renderitzar
  let ready;

  class ValidateAsyncComponent extends React.Component {
    static displayName = 'validateAsync(' + AsyncComponent.displayName + ')';
    constructor(props) {
      super(props);
      this.loaded = false;
    }

    render() {
      let component;
      this.config = this.props.config || {};
      const { children } = this.props;
      if (this.props.ready) {
        window.availabilityReactTestingMode &&
          !this.loaded &&
          console.log(
            '%cAsyncLoger: ' +
              '%c' +
              AsyncComponent.displayName +
              ' -> ' +
              '%cCompleted ' +
              '%c' +
              this.props.accInfo.toString(),
            'background: #222; color: #bada55',
            'background: #222; color: #c6c6c6', // Default color
            'background: #222; color: #46ea25',
            'background: #222; color: #c6c6c6'
          );

        this.loaded = true;
        return React.createElement(
          AsyncComponent,
          {
            config: this.config,
            ...this.props
          },
          this.props.children
        );
      } else {
        this.loaded = false;
        window.availabilityReactTestingMode &&
          console.log(
            '%cAsyncLoger: ' +
              '%c' +
              AsyncComponent.displayName +
              ' -> ' +
              '%cUnloaded ' +
              '%c' +
              this.props.accInfo.toString(),
            'background: #222; color: #bada55',
            'background: #222; color: #c6c6c6',
            'background: #222; color: #d81111',
            'background: #222; color: #c6c6c6'
          );
        component = Children.only(
          is(Function, LoadingFragment) ? (
            LoadingFragment({
              ...this.props
            })
          ) : is(Array, LoadingFragment) ? (
            <React.Fragment>{children}</React.Fragment>
          ) : (
            LoadingFragment || <div />
          )
        );
      }
      return component;
    }
  }

  const mapDispatchToProps = dispatch => {
    return {};
  };

  const mapStateToProps = (store, ownProps) => {
    const childrenProps = childrenMapStateToProps(store, ownProps),
      childrenPropsKeys = Object.keys(childrenProps);
    let completedProps = 0;
    let accInfo = [];
    childrenPropsKeys.forEach(key => {
      if ((propExceptions && propExceptions.indexOf(key) !== -1) || typeof childrenProps[key] !== 'undefined') {
        completedProps++;
      } else {
        window.availabilityReactTestingMode && accInfo.push(key);
      }
    });
    ready = completedProps === childrenPropsKeys.length;
    return {
      accInfo: accInfo,
      ready: ready,
      ...childrenProps
    };
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(ValidateAsyncComponent);
};
